import categoryApi from '@/api/category'

const state = {
  items: []
}

const mutations = {
  SET_ITEMS(state, payload) {
    state.items = payload
  }
}

const actions = {
  async fetchItems({ commit }, businessId) {
    const response = await categoryApi.get(businessId)
    commit('SET_ITEMS', response)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
